import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable , throwError } from 'rxjs';
import { PageNotificationService } from './page-notification';
import { RestUrlsConfig } from '@signature-it/ngx-generic/config';

@Injectable({
    providedIn: 'root'
})
export class CommonService {

    protected baseUrl = `${this.restUrlsConf.appURL}`;
    protected publicBaseUrl = `${this.restUrlsConf.appURL}/public`;
    protected adminBaseUrl = `${this.restUrlsConf.appURL}/admin`;

    constructor(protected http: HttpClient,
                protected restUrlsConf: RestUrlsConfig,
                protected notifySvc: PageNotificationService) {}

    protected toJSON(res: HttpResponse<any>) {
        return res;
    }

    protected handleError(error: any, notify: boolean = true) {
        if (notify) {
            this.notifySvc.set(error).show();
        }
        return throwError(error);
    }

}
